let map;
let markers = [];
const locations = [
    { name: "London Office", lat: 51.5074, lng: -0.1278, category: "office" },
    { name: "Manchester Reseller", lat: 53.4808, lng: -2.2426, category: "reseller" },
    { name: "Birmingham Office", lat: 52.4862, lng: -1.8904, category: "office" }
];

function initMap() {
    map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 52.5, lng: -1.9 },
        zoom: 6
    });

    plotLocations(locations);
	initAutocomplete();
	
}

function plotLocations(filteredLocations) {

  
    clearMarkers();
    document.getElementById('locationsList').innerHTML = '';

    filteredLocations.forEach((loc, index) => {
const marker = new google.maps.Marker({
            position: { lat: loc.lat, lng: loc.lng },
            map,
            title: loc.name,
            gmpClickable: true
           
        });

    
		
		const infoWindow = new google.maps.InfoWindow();

        marker.addListener('click', () => {
            /* infoWindow.open(map, marker);*/
			infoWindow.close();
			infoWindow.setContent(marker.title);
			infoWindow.open(marker.map, marker);
        });

        // Accessibility: add keyboard interaction
        google.maps.event.addListener(marker, 'keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                infoWindow.open(map, marker);
            }
        });

        markers.push(marker);

        const item = document.createElement('div');
        item.className = 'location-item';
        item.textContent = `${loc.name} (${loc.category})`;
        item.addEventListener('mouseenter', () => marker.setAnimation(google.maps.Animation.BOUNCE));
        item.addEventListener('mouseleave', () => marker.setAnimation(null));
        item.addEventListener('click', () => {
            map.setCenter(marker.getPosition());
            map.setZoom(12);
        });

        document.getElementById('locationsList').appendChild(item);
    });
}

function clearMarkers() {
    markers.forEach(marker => marker.setMap(null));
    markers = [];
}

document.getElementById('searchBtn').addEventListener('click', () => {
    const address = document.getElementById('addressInput').value;
    const category = document.getElementById('categoryFilter').value;
    const radius = parseInt(document.getElementById('radiusFilter').value);

    if (!address) {
        alert('Please enter a location.');
        return;
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK') {
            const userLocation = results[0].geometry.location;
            map.setCenter(userLocation);
            map.setZoom(8);

            const filtered = locations.filter(loc => {
                const distance = google.maps.geometry.spherical.computeDistanceBetween(
                    userLocation,
                    new google.maps.LatLng(loc.lat, loc.lng)
                ) / 1609.34; // miles

                return distance <= radius && (category === 'all' || loc.category === category);
            });

            plotLocations(filtered);
        } else {
            alert('Geocode failed: ' + status);
        }
    });
});



let autocomplete;

function initAutocomplete() {
    autocomplete = new google.maps.places.Autocomplete(
        document.getElementById('addressInput'),
        {
            types: ['(cities)'], // Or use ['geocode'] for addresses
            componentRestrictions: { country: 'GB' } // Restrict to UK
        }
    );

    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        console.log('Selected location:', place.formatted_address);
    });
}
